export default "__VITE_ASSET__9u4z3ZQW__"